export const ADMIN_TOKEN_KEY = "token";
export const ADMIN_SESSION_COOKIE_KEY = "admin_session_token";

export const createAdminSessionCookieStore = ({
  documentObject = window.document,
  protocol = window.location.protocol
} = {}) => {
  const cookieAttributes = `Path=/; SameSite=Strict${
    protocol === "https:" ? "; Secure" : ""
  }`;

  return {
    getItem(key) {
      const encodedKey = `${encodeURIComponent(key)}=`;
      const cookie = documentObject.cookie
        .split(";")
        .map((part) => part.trim())
        .find((part) => part.startsWith(encodedKey));

      return cookie
        ? decodeURIComponent(cookie.slice(encodedKey.length))
        : null;
    },
    setItem(key, value) {
      documentObject.cookie =
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}; ` +
        cookieAttributes;
    },
    removeItem(key) {
      documentObject.cookie =
        `${encodeURIComponent(key)}=; Max-Age=0; ${cookieAttributes}`;
    }
  };
};

const getDefaultStores = () => ({
  sessionCookie: createAdminSessionCookieStore(),
  sessionStorage: window.sessionStorage,
  localStorage: window.localStorage
});

export const getAdminToken = (stores = getDefaultStores()) =>
  stores.sessionCookie.getItem(ADMIN_SESSION_COOKIE_KEY) ||
  stores.sessionStorage.getItem(ADMIN_TOKEN_KEY) ||
  stores.localStorage.getItem(ADMIN_TOKEN_KEY);

export const hasAdminToken = (stores = getDefaultStores()) =>
  Boolean(getAdminToken(stores));

export const clearAdminToken = (stores = getDefaultStores()) => {
  stores.sessionCookie.removeItem(ADMIN_SESSION_COOKIE_KEY);
  stores.sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  stores.localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const saveAdminToken = (
  token,
  { rememberMe = false, stores = getDefaultStores() } = {}
) => {
  clearAdminToken(stores);
  if (rememberMe) {
    stores.localStorage.setItem(ADMIN_TOKEN_KEY, token);
    return;
  }
  stores.sessionCookie.setItem(ADMIN_SESSION_COOKIE_KEY, token);
};
